import { Dispatch, SetStateAction } from 'react';
import { useAccount } from '@/account/useAccount';
import { useAppConstantsContext } from '@/context/AppConstants';
import { PremiumPaymentCard } from '@/reports/shared/PremiumPaymentModal/PremiumPaymentCard';
import { useTheme, Stack, Text } from '@/theme/index';
import { checkSingleReportVariations } from '@/utils/checkSingleReportVariations';
import { BannerContainer, BannerIconWrapper } from './components';

export interface UpgradePlanBannerdProps {
  index: number;
  setIndex: Dispatch<SetStateAction<number>>;
  openSuccessModal?: () => void;
  handleClick: () => void;
}

/**
 * This component is responsible for showing the User the
 * option of adding more options to his/her current plan.
 */
export const UpgradePlanBanner = ({
  index,
  setIndex,
  openSuccessModal,
  handleClick,
}: UpgradePlanBannerdProps) => {
  const theme = useTheme();
  const { data: account } = useAccount(true);

  const {
    images: { imgRocket },
    variationPlanNames,
    internationalPlanNames,
  } = useAppConstantsContext();

  const reportVariations =
    account && internationalPlanNames
      ? checkSingleReportVariations(
          account,
          variationPlanNames,
          internationalPlanNames
        )
      : null;
  const isInSingleReportVariation =
    reportVariations?.isInSingleReportVariation ?? false;

  if (!isInSingleReportVariation) return null;

  return (
    <BannerContainer>
      <BannerIconWrapper sx={{ backgroundImage: `url(${imgRocket})` }} />
      <Stack direction="column">
        <Text fontSize={theme.typography.h3.fontSize} margin={0}>
          All plans unlock additional search options of names, phones, addresses
          & more!&nbsp;
          <span
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
            onClick={handleClick}
          >
            Click here
          </span>
          &nbsp;to only add the search options to your current plan.
        </Text>
        <PremiumPaymentCard
          index={index}
          setIndex={setIndex}
          openSuccessModal={openSuccessModal}
        />
      </Stack>
    </BannerContainer>
  );
};
